import { z } from 'zod'
import type { Session } from '@/features/auth/types'

/** Missing or stale capabilities never imply medical-record access. */
export function complianceAccessMode(session: Session, shared: boolean) {
  if (!session.location) return 'none'
  if (!shared)
    return ['branch_manager', 'branch_staff'].includes(session.role.key) ? 'full' : 'none'
  const access = session.complianceAccess
  if (access?.locationId !== session.location.publicId) return 'none'
  if (access.fullForm === true) return 'full'
  return access.readExclusions === true ? 'exclusions' : 'none'
}

const base = z.strictObject({
  revision: z.number().int().nonnegative(),
  scope: z.strictObject({ locationId: z.string().min(1), customerId: z.string().min(1) }),
})
export const exclusionViewSchema = z.discriminatedUnion('clearance', [
  base.extend({ clearance: z.literal('missing') }),
  base.extend({
    clearance: z.enum(['ready', 'review']),
    submissionId: z.string().min(1),
    signedAt: z.iso.datetime(),
    version: z.string().min(1),
    questions: z
      .array(
        z.strictObject({
          id: z.string().min(1),
          label: z.string().min(1),
          answer: z.enum(['YES', 'NO']),
        }),
      )
      .min(1),
  }),
])
